const binding = { modules: {}, dataActions: {} };

    (binding.modules['account-lookup'] = {
        c: () => require('partner/modules/account-lookup/account-lookup.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'account-lookup',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/account-lookup'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };